import useEmitter from '@/composables/useEmitter'

const emitter = useEmitter()

export const shadowTargetEvent = 'shadowTarget'

export function updateTarget(target) {
    emitter?.emit(shadowTargetEvent, target)
}
